import { SupportedLanguage } from '@/enum'
import { DropdownOption } from '@/types'

export const GAN_OPTIONS: DropdownOption = {
  [SupportedLanguage.English]: [],
  [SupportedLanguage.Hindi]: [],
  [SupportedLanguage.Bengali]: [],
  [SupportedLanguage.Telugu]: [],
  [SupportedLanguage.Marathi]: ['मनुष्य', 'राक्षस', 'देव'],
  [SupportedLanguage.Tamil]: [],
  [SupportedLanguage.Gujarati]: [],
  [SupportedLanguage.Kannada]: [],
  [SupportedLanguage.Malayalam]: [],
  [SupportedLanguage.Odia]: [],
}
